<template>
  <div class="app-container">
    <div class="flex items-start justify-between gap-6 xl:flex-col">
      <Tools :mode="mode" />
      <div class="flex-1 xl:w-full">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Tools from "@C/Layouts/Tools.vue";

export default {
  name: "AuthLayout",
  props: {
    mode: String,
  },
  components: {
    Tools,
  },
};
</script>
